export const capitalizeFirstLetter = (str: string): string => {
	if (!str) return '';
	if (str.length === 0) {
		return str;
	}

	const upperCaseFirstLetter = str.charAt(0).toUpperCase();

	return upperCaseFirstLetter + str.toLowerCase().slice(1);
};

const HTML_ESCAPE_MAP: Record<string, string> = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#39;',
};

export function escapeHtml(str: string): string {
	return str.replace(/[&<>"']/g, (char) => HTML_ESCAPE_MAP[char]);
}

export function safeStringify(obj: any) {
	try {
		return JSON.stringify(obj);
	} catch {
		return 'null';
	}
}
